export default __webpack_public_path__ + "static/foregroundDirectors-0d6b17971657e9e6de2457894ab76c2d.png";